/**
 * 项目分类（层次主类目编码），1-国开，2-成教，3-自考，4-网教
 * @param {*} code 编码
 * @returns 
 */
export function getDegreeCategory(code) {
  let majorObj = { 1: '国开', 2: '成教', 3: '自考', 4: '网教' };
  return majorObj[code];
}

/**
 *  分转元
 * @param {*} srcFen 分
 */
export function fenToYuan(srcFen) {
  let reData = 0;
  if (srcFen !== '' && srcFen !== null && srcFen !== undefined) {
    reData = Number(srcFen / 100).toFixed(2);
  }
  return reData;
}

/**
* 元转分
* @param {*} srcYuan 元
*/
export function yuanToFen(srcYuan) {
  let reData = 0;
  if (srcYuan !== 0 && srcYuan !== null && srcYuan !== undefined) {
    reData = parseInt(Number(srcYuan) * 100);
  }
  return reData;
}



// WEBPACK FOOTER //
// ./src/utils/global.js